import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";

const InfoItem = ({ label, value }) => (
  <div>
    <div className="text-[11px] uppercase tracking-wide text-slate-500">
      {label}
    </div>
    <div className="mt-1 text-sm font-medium text-slate-900 break-all">
      {value ?? "—"}
    </div>
  </div>
);

const ParticipantDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const user = state?.user;
  const p = user?.participant_info;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Outer container with more left/right space */}
      <div className="max-w-10xl mx-auto px-10 py-6 mt-4">
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-lg font-semibold">Participant Details</h2>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center rounded-lg border border-slate-200 bg-white p-2 shadow-sm hover:bg-slate-50"
            aria-label="Go back"
            title="Back"
          >
            {/* Black back icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="h-5 w-5"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
            <span className="font-semibold text-sm">Back</span>
          </button>
        </div>

        {/* Shadow container with extra padding */}
        <div className="bg-white shadow-md rounded-2xl px-8 py-6">
          {!user ? (
            <p className="text-gray-600">No participant selected.</p>
          ) : (
            p && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-y-6 gap-x-8">
                <InfoItem label="Full Name" value={p?.full_name} />
                <InfoItem label="Email" value={p?.email} />
                <InfoItem label="Mobile" value={p?.mobile} />
                <InfoItem label="Type" value={p?.participant_type} />
                <InfoItem label="Company" value={p?.company_name} />
                <InfoItem label="Designation" value={p?.designation} />
                <InfoItem label="Industry" value={p?.industry} />
                <InfoItem label="City/State" value={p?.city_state} />
                <InfoItem label="Employees" value={p?.employee_range} />
                <InfoItem label="Experience" value={p?.experience_range} />
                <InfoItem
                  label="Wants Updates"
                  value={
                    p?.wants_updates === true
                      ? "Yes"
                      : p?.wants_updates === false
                        ? "No"
                        : "—"
                  }
                />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ParticipantDetails;
